import BaseStore from '../components/BaseStore'

export default {
  name: 'BaseData',
  extends: BaseStore,
  data () {
    let beginTime = new Date()
    beginTime.setDate(beginTime.getDate() - 3)
    let endTime = new Date()
    endTime.setDate(endTime.getDate() - 1)

    return {
      query: {
        beginTime: beginTime.format('YYYY/MM/DD 00:00:00'),
        endTime: endTime.format('YYYY/MM/DD 23:59:59')
      }
    }
  },
  computed: {
    siteDeviceCategory: () => 0,
    startDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() > new Date(this.query.endTime)
      }
    },
    endDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() < new Date(this.query.beginTime)
      }
    },
    siteDevices () {
      let {siteDeviceCategory} = this
      return this.profileSiteDevices.filter(siteDevice => siteDevice.categoryId & siteDeviceCategory)
    },
    sites () {
      let siteDeviceMap = this.siteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let siteDevices = map[siteId]

        if (!Array.isArray(siteDevices)) {
          siteDevices = map[siteId] = []
        }

        siteDevices.push(siteDevice)

        return map
      }, {})

      return Object.freeze(this.profileSites.filter(site => siteDeviceMap[site.id]).map(site => Object.freeze({
        ...site,
        siteDevices: siteDeviceMap[site.id]
      })))
    },
    // selectedSiteDevices () {
    //   let {siteId} = this.query
    //   return this.siteDevices.filter(siteDevice => siteDevice.siteId === siteId)
    // },
    selectedSiteDevice () {
      let {siteDeviceId} = this.query
      return this.siteDevices.find(siteDevice => siteDevice.id === siteDeviceId)
    },
    selectedSiteDeviceFactors () {
      return (this.selectedSiteDevice || {siteDeviceFactors: []}).siteDeviceFactors
    }
  },
  methods: {
    onSitesChanged () {}
  },
  watch: {
    sites: {
      immediate: true,
      handler (newVal) {
        if (newVal.length > 0) {
          this.onSitesChanged()
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/BaseData.js